import SynaptiqLogo from '../../../assets/images/icons/header-icon.svg';
import { getStepUpToken, isStepUpRequired, STEP_UP_HEADER } from '../../util/adminStepUp';
import { secureColumns } from '../../util/cardHtml';

const getConfig = ({ onStepUpRequired } = {}) => (
    {
        "dom": '<<t><"bottom"pl>>',
        columns,
        order: [[0, "desc"]],
        responsive: true,
        processing: true,
        serverSide: true,
        ajax: {
            url: 'api/v1/datatables/user',
            // the 24-hour passkey step-up (util/adminStepUp)
            beforeSend: (xhr) => { const token = getStepUpToken(); if (token) xhr.setRequestHeader(STEP_UP_HEADER, token); },
            error: (xhr) => { if (isStepUpRequired(xhr) && onStepUpRequired) onStepUpRequired(); },
        },
    }
)

const columns = secureColumns([
    {
        title: 'Id',
        data: 'id'
    },
    {
        title: 'First Name',
        data: 'first_name',
    },
    {
        title: 'Last Name',
        data: 'last_name',
    },
    {
        title: 'Email',
        data: 'email'
    },
    {
        data: 'id',
        sortable: false,
        className: 'actions',
        width: '240px',
        render: (data, type, full) => (`<button class="button button--secondary button--small button--impersonate-user" aria-label="Impersonate User" data-user-id="${data}">Impersonate</button>`)
    },
]);

export default getConfig;